export const theme = {
  addressColor: Styles.color.grey.one,
  ammenityIconFill: Styles.color.grey.one,
  innerAnchorColor: Styles.color.grey.one,
  innerColor: Styles.color.grey.one,
  innerPColor: Styles.color.grey.one,
  modalBackground: Styles.color.white,
  phoneNumberColor: Styles.color.grey.one,
};
